import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";
import {
  FaTachometerAlt,
  FaChartBar,
  FaBookOpen,
  FaCogs,
  FaPause,
  FaPaperPlane,
  FaCog,
  FaFolder,
  FaBullseye,
  FaArrowLeft,
  FaThumbsUp,
  FaSpinner,
  FaBuilding,
  FaThumbsDown,
  FaTrash,
  FaCommentDots,
  FaFileExport,
  FaFileAlt,
  FaUserSlash,
  FaAngleDown,
  FaAngleRight,
  FaTimes,
} from "react-icons/fa";

const Sidebar = ({ currentPage, isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({
    leads: false,
    applications: false,
    disbursal: false,
  });

  // Auto-expand menu if current route matches
  useEffect(() => {
    if (location.pathname.startsWith("/leads")) {
      setExpandedMenus(prev => ({ ...prev, leads: true }));
    }
  }, [location.pathname]);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024 && setIsOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setIsOpen]);

  const toggleMenu = (menu) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleMenuClick = () => {
    if (window.innerWidth <= 1024 && setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div 
          className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
          onClick={() => setIsOpen && setIsOpen(false)}
        />
      )}
      
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        {/* Close button for mobile */}
        {window.innerWidth <= 1024 && (
          <div className="sidebar-close-btn" onClick={() => setIsOpen && setIsOpen(false)}>
            <FaTimes />
          </div>
        )}
        
        <div className="sidebar-logo">NOVUS</div>

      <ul className="sidebar-menu">
        <li 
          className={`menu-item ${location.pathname === "/dashboard" ? "active" : ""}`}
          onClick={() => {
            handleNavigation("/dashboard");
            handleMenuClick();
          }}
        >
          <FaTachometerAlt /> Dashboard
        </li>

        <li className="menu-item">
          <FaChartBar /> Enquiry
        </li>

        {/* Leads Section */}
        <li className="menu-item has-submenu" onClick={() => toggleMenu("leads")}>
          <div className="menu-header">
            <span>
              <FaBookOpen /> Leads
            </span>
            {expandedMenus.leads ? <FaAngleDown /> : <FaAngleRight />}
          </div>
          {expandedMenus.leads && (
            <ul className="submenu">
              <li 
                className={location.pathname === "/leads/new" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/leads/new");
                  handleMenuClick();
                }}
              >
                Leads New
              </li>
              <li 
                className={location.pathname === "/leads/in-process" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/leads/in-process");
                  handleMenuClick();
                }}
              >
                Leads In Process
              </li>
              <li 
                className={location.pathname === "/leads/hold" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/leads/hold");
                  handleMenuClick();
                }}
              >
                Leads Hold
              </li>
            </ul>
          )}
        </li>

        {/* Applications Section */}
        <li
          className="menu-item has-submenu"
          onClick={() => toggleMenu("applications")}
        >
          <div className="menu-header">
            <span>
              <FaPaperPlane /> Applications
            </span>
            {expandedMenus.applications ? <FaAngleDown /> : <FaAngleRight />}
          </div>
          {expandedMenus.applications && (
            <ul className="submenu">
              <li 
                className={location.pathname === "/applications/new" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/applications/new");
                  handleMenuClick();
                }}
              >
                Applications New
              </li>
              <li
                className={location.pathname === "/applications/in-process" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/applications/in-process");
                  handleMenuClick();
                }}
              >
                Applications In Process
              </li>
              <li
                className={location.pathname === "/applications/hold" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/applications/hold");
                  handleMenuClick();
                }}
              >
                Applications Hold
              </li>
              <li
                className={location.pathname === "/applications/recommended" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/applications/recommended");
                  handleMenuClick();
                }}
              >
                Applications Recommended
              </li>
              <li
                className={location.pathname === "/applications/sent-back" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/applications/sent-back");
                  handleMenuClick();
                }}
              >
                Applications Sent Back
              </li>
            </ul>
          )}
        </li>

        <li 
          className={`menu-item ${location.pathname === "/sanctioned" ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/sanctioned");
            handleMenuClick();
          }}
        >
          <FaThumbsUp /> Sanctioned
        </li>

        {/* Disbursal Section */}
        <li
          className="menu-item has-submenu"
          onClick={() => toggleMenu("disbursal")}
        >
          <div className="menu-header">
            <span>
              <FaBuilding /> Disbursal
            </span>
            {expandedMenus.disbursal ? <FaAngleDown /> : <FaAngleRight />}
          </div>
          {expandedMenus.disbursal && (
            <ul className="submenu">
              <li
                className={location.pathname === "/disbursal/new" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/disbursal/new");
                  handleMenuClick();
                }}
              >
                Disbursal New
              </li>
              <li
                className={location.pathname === "/disbursal/in-process" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/disbursal/in-process");
                  handleMenuClick();
                }}
              >
                Disbursal In Process
              </li>
              <li
                className={location.pathname === "/disbursal/send-back" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/disbursal/send-back");
                  handleMenuClick();
                }}
              >
                Disbursal Send Back
              </li>
              <li
                className={location.pathname === "/disbursal/hold" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/disbursal/hold");
                  handleMenuClick();
                }}
              >
                Disbursal Hold
              </li>
              <li
                className={location.pathname === "/disbursal/pending" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/disbursal/pending");
                  handleMenuClick();
                }}
              >
                Disburse Pending
              </li>
              <li
                className={location.pathname === "/disbursal/disbursed" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/disbursal/disbursed");
                  handleMenuClick();
                }}
              >
                Disbursed
              </li>
              <li
                className={location.pathname === "/disbursal/waived-off" ? "active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/disbursal/waived-off");
                  handleMenuClick();
                }}
              >
                Disbursed Waived
              </li>
            </ul>
          )}
        </li>

        <li 
          className={`menu-item ${location.pathname === "/rejected-apps" ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/rejected-apps");
            handleMenuClick();
          }}
        >
          <FaTrash /> Rejected Apps
        </li>

        <li 
          className={`menu-item ${location.pathname === "/verification-status" ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/verification-status");
            handleMenuClick();
          }}
        >
          <FaPaperPlane /> Verification Status
        </li>

        <li 
          className={`menu-item ${location.pathname === "/customer-feedback" ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/customer-feedback");
            handleMenuClick();
          }}
        >
          <FaCommentDots /> Customer Feedback
        </li>

        <li 
          className={`menu-item ${location.pathname === "/export" ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/export");
            handleMenuClick();
          }}
        >
          <FaFileExport /> Export
        </li>

        <li 
          className={`menu-item ${location.pathname === "/mis-report" ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/mis-report");
            handleMenuClick();
          }}
        >
          <FaFileAlt /> MIS Report
        </li>

        <li 
          className={`menu-item ${location.pathname === "/blacklist-user" ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/blacklist-user");
            handleMenuClick();
          }}
        >
          <FaUserSlash /> Blacklist User
        </li>
      </ul>
    </aside>
    </>
  );
};

export default Sidebar;
